{
  "warning": {
    "addProperty": {
      "title": "Eiendom {{propertyNumber}} tilhører allerede andelseierskapet til {{memberName}}",
      "bodyTransferWithCapital": "Skal eiendommen overdras med andelskapital, må overføringen gjøres fra {{memberName}} sin skogeierprofil.",
      "bodyTransferWithoutCapital": "Hvis du legger til eiendommen her, overføres den uten andelskapital og tilhørende fordeler fra andelseierskapet."
    },
    "addPropertyGeneric": {
      "title": "Eiendom {{propertyNumber}} er tilknyttet et andelseierskap",
      "bodyTransferWithCapital": "Skal eiendommen overdras med andelskapital, må overføringen gjøres fra nåværende andelseier sin skogeierprofil.",
      "bodyTransferWithoutCapital": "Hvis du legger til eiendommen her, overføres den uten andelskapital og tilhørende fordeler fra andelseierskapet."
    },
    "documentOwnership": {
      "sectionTitle": "Overfør eiendom uten tilhørende andelskapital",
      "bodyIncluded": "Denne eiendommen er inkludert i andelseierskapet til {{memberName}}. Hvis du dokumenterer eierskap eller eksklusiv bruksrett her, overføres eiendommen fra dagens medlemskap uten andelskapital.",
      "bodyTransferWithCapital": "Hvis eiendommen skal overdras med andelskapital, må overdragelsen gjennomføres fra skogeierprofilen til nåværende andelseier.",
      "openMemberProfile": "Åpne {{memberName}} profil",
      "confirmTitle": "Overfør eiendom uten andelskapital",
      "confirmDescription": "Denne handlingen kan ikke reverseres. Er du sikker på at du ønsker å fortsette?",
      "confirmContinue": "Overfør",
      "confirmCancel": "Avbryt"
    },
    "documentOwnershipGeneric": {
      "sectionTitle": "Overfør eiendom uten tilhørende andelskapital",
      "body": "Denne eiendommen er tilknyttet et andelseierskap. Hvis du dokumenterer eierskap eller eksklusiv bruksrett her, overføres eiendommen fra dagens andelseierskap uten andelskapital.",
      "bodyTransferWithCapital": "Hvis eiendommen skal overdras med andelskapital, må overdragelsen gjennomføres fra skogeierprofilen til nåværende andelseier."
    },
    "continueWithoutCapital": "Overfør uten andelskapital",
    "cancel": "Avbryt",
    "propertyBlockedByShareholder": {
      "title": "Eiendom {{propertyNumber}} tilhører allerede andelseierskapet til {{memberName}}",
      "body": "Eiendommen kan derfor ikke legges til her. Skal eiendommen overdras, må det gjøres fra skogeierprofilen til {{memberName}} kundenummer {{memberCustomerNumber}}",
      "close": "Lukk",
      "goToProfile": "Gå til skogeierprofil"
    },
    "propertyBlockedByShareholderGeneric": {
      "title": "Eiendom {{propertyNumber}} tilhører allerede et andelseierskap",
      "body": "Eiendommen kan derfor ikke legges til her. Skal eiendommen overdras, må det gjøres fra skogeierprofilen til nåværende andelseier.",
      "close": "Lukk"
    }
  }
}
